import { motion } from "framer-motion";
import { PenLine, Disc3, PartyPopper } from "lucide-react";

const FALLBACK = [
  { title: "Share Your Memories", body: "Names, inside jokes, dates & the vibe — one quick 1-minute form." },
  { title: "Pro Artists Craft It", body: "Professional lyrics, real vocals & a studio-quality track." },
  { title: "Receive & Wow Them", body: "Delivered in 12 hours as an MP3 + printable lyric card." },
];

const icons = [PenLine, Disc3, PartyPopper];
const nClses = ["bg-pink text-white", "bg-sunny text-ink", "bg-mint text-ink"];
const rotates = ["rotate-[-2deg]", "rotate-[1.5deg]", "rotate-[-1deg]"];

export default function HowItWorks({ content }) {
  const steps = content?.steps?.length ? content.steps : FALLBACK;
  return (
    <section id="how-it-works" className="py-20 sm:py-28 scroll-mt-24 bg-cardalt border-y-[3px] border-ink" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6 }}>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-pink font-semibold mb-4">How it works</p>
          <h2 className="font-display font-bold text-4xl sm:text-5xl tracking-tight leading-[1.1]">
            Three steps to <span className="text-tangerine">happy tears</span>
          </h2>
        </motion.div>

        <div className="mt-14 grid md:grid-cols-3 gap-7">
          {steps.map((s, i) => {
            const Icon = icons[i % icons.length];
            return (
              <motion.div
                key={s.title + i}
                data-testid={`how-step-${i + 1}`}
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, delay: i * 0.12, type: "spring", bounce: 0.3 }}
                className={`sticker-card relative rounded-3xl bg-white p-8 text-left ${rotates[i % rotates.length]}`}
              >
                <span className={`sticker absolute -top-4 -left-3 w-11 h-11 rounded-full border-2 border-ink flex items-center justify-center font-display font-bold text-lg ${nClses[i % nClses.length]}`}>
                  {i + 1}
                </span>
                <div className="w-12 h-12 rounded-2xl bg-cream border-2 border-ink flex items-center justify-center text-ink mt-2">
                  <Icon size={22} />
                </div>
                <h3 className="mt-5 font-display font-semibold text-2xl">{s.title}</h3>
                <p className="mt-2.5 text-sm text-plum font-medium leading-relaxed">{s.body}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
